<template>
  <div>
    <v-menu
      v-model="value"
      close-on-click
      :close-on-content-click="false"
      content-class="NotificationsIcon-menuContainer"
    >
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" icon>
          <v-badge
            left
            :content="newNotifications.length"
            :value="newNotifications.length > 0 && !value"
            color="notification"
            overlap
          >
            <v-icon>mdi-bell</v-icon>
          </v-badge>
        </v-btn>
      </template>
      <NotificationsMenu :notifications="notifications" />
    </v-menu>
  </div>
</template>

<script>
import NotificationsMenu from '@/components/ui/notifications/NotificationsMenu'
import gql from 'graphql-tag'

const GET_NOTIFICATION = gql`
  query newNotifications($lang: String, $limit: Int, $shopUuid: GUID!) {
    newNotifications(limit: $limit, shopUuid: $shopUuid) {
      appointmentId
      createdAt
      notificationId
      notificationType
      shopUuid
      appointment {
        appointmentId
        beginDateTime
        comment
        customerEmail
        customerFullName
        customerPhoneNumber
        duration
        endDateTime
        serviceUuid
        age
        personaType
        service {
          color
          serviceType
          serviceUuid
          name(lang: $lang)
        }
        status
      }
    }
  }
`

const ACKNOWLEDGE_NOTIFICATIONS = gql`
  mutation acknowledgeNotifications($shopUuid: GUID!) {
    acknowledgeNotifications(shopUuid: $shopUuid) {
      shopUuid
    }
  }
`
export default {
  components: {
    NotificationsMenu
  },

  data: () => ({
    value: false,
    unsubscribe: null
  }),

  computed: {
    newNotifications() {
      return this.notifications.filter(notification => notification.new)
    },
    notifications() {
      if (!this.downloadNotifications) return []

      return this.downloadNotifications.map(notification => ({
        new: new Date(notification.createdAt) > new Date(this.$store.getters.currentShop.notificationACKUpdatedAt),
        ...notification
      }))
    }
  },

  apollo: {
    downloadNotifications: {
      query: GET_NOTIFICATION,
      variables() {
        return {
          lang: this.$vuetify.lang.current,
          limit: 15,
          shopUuid: this.$store.state.currentShopUuid
        }
      },
      update: ({ newNotifications }) => newNotifications
    }
  },

  methods: {
    async acknowledgeNotifications() {
      await this.$apollo.mutate({
        mutation: ACKNOWLEDGE_NOTIFICATIONS,
        variables: {
          shopUuid: this.$store.state.currentShopUuid
        }
      })
      this.$store.commit('UPDATE_NOTIFICATIONS_UPDATE_DATE')
      await this.$apollo.queries.downloadNotifications.refetch()
    },
    sendGtmOpenNotificationPanel() {
      this.$gtm.trackEvent({
        event: 'notification_center_display',
        practitioner_id: this.$store.state.myUser.ecpId,
        shopUuid: this.$store.state.currentShopUuid
      })
    }
  },

  watch: {
    value(value) {
      if (!value) {
        this.acknowledgeNotifications()
      } else {
        this.sendGtmOpenNotificationPanel()
      }
    }
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe(mutation => {
      if (mutation.type === 'SET_NOTIFICATIONS_UP_TO_DATE' && mutation.payload) {
        this.$apollo.queries.downloadNotifications.refetch()
        this.$store.commit('SET_NOTIFICATIONS_UP_TO_DATE', false)
      }
    })
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }
}
</script>

<style lang="scss">
.NotificationsIcon-menuContainer {
  max-height: 93vh;
}
.NotificationsIcon-menuContainer::-webkit-scrollbar-thumb {
  border-radius: 10px;
}
</style>
